// utils/request.js

import axios from 'axios';
import store from "@/store";

const BASE_URL = '/api';
// const BASE_URL = 'http://localhost:8000';
// const BASE_URL = 'https://www.hblaoxie.com/api';
const request = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// 请求拦截器
request.interceptors.request.use(config => {
    const accessToken = store.state.accessToken; // 从Vuex store中获取accessToken
    if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
});

// 刷新 token 的函数
const refreshToken = async () => {
    const refreshToken = store.state.refreshToken;
    if (!refreshToken) {
        handleTokenError();
        return null;
    }

    try {
        const response = await axios.post(`${BASE_URL}/auth/refresh-token`,
            { token: refreshToken },
            {
                headers: { 'Content-Type': 'application/json' },
                skipAuthRefresh: true
            }
        );

        if (response.data.success) {
            const { accessToken } = response.data.data;
            store.commit('setAccessToken', accessToken);
            return accessToken;
        } else {
            handleTokenError();
            return null;
        }
    } catch (error) {
        // console.error('Refresh token error:', error);
        handleTokenError();
        return null; // Ensure null is returned on error
    }
};

// 处理 token 错误
const handleTokenError = () => {
    store.dispatch('logout'); // 清除Vuex store中的token数据
    window.location.href = '/login';
};

// Concurrency handling variables
let isRefreshing = false;
let refreshSubscribers = [];

function onRefreshed(accessToken) {
    refreshSubscribers.map(cb => cb(accessToken));
    refreshSubscribers = [];
}

function subscribeTokenRefresh(cb) {
    refreshSubscribers.push(cb);
}

// 响应拦截器
request.interceptors.response.use(
    response => {
        if (response.data.success) {
            return response.data;
        } else {
            throw response.data;
        }
    },
    async error => {
        const originalRequest = error.config;

        if (originalRequest.skipAuthRefresh) {
            throw error;
        }

        if (error.response?.status === 401 && !originalRequest._retry) {

            if (isRefreshing) {
                return new Promise(resolve => {
                    subscribeTokenRefresh(accessToken => {
                        originalRequest.headers.Authorization = `Bearer ${accessToken}`;
                        resolve(request(originalRequest));
                    });
                });
            }

            originalRequest._retry = true;
            isRefreshing = true;

            try {
                const newAccessToken = await refreshToken();
                if (newAccessToken) {
                    // console.log('New token received:', newAccessToken);

                    // Re-send current request
                    originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;

                    // Notify other queued requests
                    onRefreshed(newAccessToken);

                    return request(originalRequest);
                }
            } catch (refreshError) {
                console.error('Token refresh failed:', refreshError);
                // No need to manually reject subscribers as handleTokenError redirects
                handleTokenError();
                throw refreshError;
            } finally {
                isRefreshing = false;
            }
        } else if (error.response?.status === 403) {
            // 屏蔽 403 强制退出，改为错误提示，方便调试权限问题
            console.error('权限不足: 您没有访问该接口的权限', error.config.url);
            // handleTokenError(); 
        }

        throw error;
    }
);

export default request;
